import { render, staticRenderFns } from "./MenuEventos.vue?vue&type=template&id=39c44940&scoped=true"
import script from "./MenuEventos.vue?vue&type=script&lang=js"
export * from "./MenuEventos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c44940",
  null
  
)

export default component.exports